module.exports = __webpack_public_path__ + "img/rules_1.b3966953.png";